import { Input as InputPrimitive } from "@base-ui/react/input"
import { cn } from "@/modules/lib/utils"
import { cva, type VariantProps } from "class-variance-authority"

const inputVariants = cva(
  cn(
    "md:text-md flex h-11 w-full min-w-0 rounded-3xl border border-borderDefault bg-transparent px-3 py-1 text-base text-textDefault-body shadow-xs transition-[color,box-shadow] outline-none selection:bg-primary-300 selection:text-textDefault-body placeholder:text-textDefault-placeholder",
    "focus:text-textDefault-body focus-visible:border-interactive-border-primary-default",
    "file:inline-flex file:h-11 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-textDefault-body",
    "hover:border-[1px] hover:border-interactive-border-primary-default",
    "disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",
    "aria-invalid:border-borderError aria-invalid:ring-borderError/20",
  ),
  {
    variants: {
      variant: {
        default: "",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
)

function Input({
  className,
  type,
  variant,
  ...props
}: React.ComponentProps<"input"> &
  VariantProps<typeof inputVariants> & { "data-testid"?: string }) {
  return (
    <InputPrimitive
      type={type}
      data-slot="input"
      className={cn(inputVariants({ variant, className }))}
      data-test-id={props["data-testid"]}
      {...props}
    />
  )
}

export { Input, inputVariants }
